import { __assign } from './node_modules/tslib/tslib.es6.js';
import * as React from 'react';

var SvgArrowExpandHor = function (props) { return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "m18 8 4 4m0 0-4 4m4-4H2m4-4-4 4m0 0 4 4" }))); };

export { SvgArrowExpandHor as default };
//# sourceMappingURL=arrow-expand-hor.js.map
